import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Deportes from './components/Deportes/deportes';
import NotFound from './components/NotFound/NotFound';
import Cotizador from './pages/Cotizador/Cotizador';
import { BrowserRouter, Routes, Route } from 'react-router-dom';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    <BrowserRouter>
      <Routes>
        <Route path='/' element={<App />} />
        <Route path='/deportes' element={<Deportes />} />
        <Route path='/cotizador' element={<Cotizador />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
    </BrowserRouter>

  </React.StrictMode>
);
